export const errorMessages: Record<string, string> = {
  'auth/invalid-credential': 'incorrectLoginPassword',
  'auth/user-not-found': 'userNotFound',
  'auth/email-already-in-use': 'emailExists',
  'auth/popup-closed-by-user': 'popupClosedByUser',
  'auth/cancelled-popup-request': 'cancelled',
};
